module.exports = __webpack_public_path__ + "static/media/water-bottle.668c04ae.jpeg";